import React, { PureComponent } from "react";
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import { subDirectory } from "../config.json";
import "../App.scss";
import BoatList from "./boat/BoatList";
import BoatSearch from "./boat/Boat";
import BoatBookingHistory from "./boat/BoatBookingHistory";
import BoatTripHistory from "./boat/BoatTripHistory";
import BoatReceipt from "./boat/BoatReceipt";
import TripReceipt from "./boat/TripReceipt";
import Payment from "./boat/Payment";
import MobileReceipt from "./boat/MobileReceipt/Receipt";
import BoatPublicProfile from "./boat/BoatPublicProfile";
import UpiTransaction from "./boat/UpiTransaction";
import BookingCancellation from "./boat/Cancellation/BookingCancellation";
import SingleBookingCancellation from "./boat/Cancellation/SingleBookingCancellation";
import ChangePassword from "./boat/ChangePassword";
import BoardingPassList from "./boat/BoardingPass/BordingPassList";
import BoardingPassTicket from "./boat/BoardingPass/BoardingPassTicket";
import CancellationHistory from "./boat/Cancellation/CancellationHistory";
import RescheduledHistory from "./boat/RescheduleNew/RescheduleHistory";
import RescheduleInfo from "./boat/RescheduleNew/Rescheduleinfo";
import Reschedule from "./boat/RescheduleNew/Reschedule";
// import ReschedulingRes from "./boat/Reschedule/ReschedulingRes";
import PaymentPage from "./boat/PaymentPage/PaymentPage";
import CounterPin from "./boat/CounterPin/CounterPin";

class App extends PureComponent {
  constructor(props) {
    super(props);
  }
  componentDidMount = async () => {};
  render() {
    return (
      <Router>
        <Switch>
          {/* BoatHouseId~BookingId~BookingDate */}

          <Route path={`${subDirectory}/boat`} exact component={BoatSearch} />
          <Route path={`${subDirectory}/boat-list`} component={BoatList} />
          {/* <Route path={`${subDirectory}/login`} exact component={LoginRouting} /> */}
          <Route path={`${subDirectory}/boatBookingHistory`} component={BoatBookingHistory} />
          <Route path={`${subDirectory}/boatTripHistory`} component={BoatTripHistory} />
          <Route path={`${subDirectory}/booking-receipt`} component={BoatReceipt} />
          <Route path={`${subDirectory}/trip-receipt`} component={TripReceipt} />
          <Route path={`${subDirectory}/payment`} component={Payment} />
          <Route path={`${subDirectory}/mobilereceipt`} component={MobileReceipt} />
          <Route path={`${subDirectory}/public-profile`} component={BoatPublicProfile} />
          <Route path={`${subDirectory}/Routing`} component={UpiTransaction} />
          <Route path={`${subDirectory}/boatBookingCancellation`} component={BookingCancellation} />
          <Route path={`${subDirectory}/singleBookingCancellation`} component={SingleBookingCancellation} />
          <Route path={`${subDirectory}/changePassword`} component={ChangePassword} />
          <Route path={`${subDirectory}/boardingPass`} component={BoardingPassList} />
          <Route path={`${subDirectory}/boardingPassTicket`} component={BoardingPassTicket} />
          <Route path={`${subDirectory}/cancellationHistory`} component={CancellationHistory} />
          {/* <Route path={`${subDirectory}/rescheduleHistory`} component={RescheduleHistory} /> */}

          <Route path={`${subDirectory}/RescheduleHistory`} component={RescheduledHistory} />
          <Route path={`${subDirectory}/Reschedule`} component={Reschedule} />
          <Route path={`${subDirectory}/RescheduleInfo`} component={RescheduleInfo} />
          {/* <Route path={`${subDirectory}/RescheduleReceipt`} component={ReschedulingRes} /> */}
          <Route path={`${subDirectory}/boatPaymentPage`} component={PaymentPage} />
          <Route path={`${subDirectory}/counterPin`} component={CounterPin} />

          <Redirect to={`${subDirectory}/boat`}></Redirect>
        </Switch>
      </Router>
    );
  }
}
export default App;
